import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import "./Consulta.css"

const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwC1rVhzYySEfdZ5Yqs-zlejtfjYeE9ASr0J2EfKBakADYiASSIfiHi1EHHD2TkDhmc/exec"

const DESTINOS = [
  "Búzios","Río + Búzios","Río de Janeiro",
  "Arraial do Cabo","Búzios + Arraial","Cabo Frío",
  "Maceió + Maragogi","Otro"
]
const ZONAS_BUZIOS  = ["Zona Céntrica","Joao Fernandes","Ferradura","Tartaruga"]
const CIUDADES      = ["Buenos Aires","Córdoba","Mendoza","Rosario","Otra"]
const TIPOS_VIAJE   = [
  { val:"economico",  emoji:"🎒", label:"Económico",  desc:"Mejor relación precio-calidad" },
  { val:"intermedio", emoji:"⚖️", label:"Intermedio", desc:"Comodidad y buena ubicación" },
  { val:"exclusivo",  emoji:"👑", label:"Exclusivo",  desc:"Sin compromisos, lo mejor" },
]

const PASOS = [
  { num:1, label:"Destino y fecha" },
  { num:2, label:"Tu viaje"        },
  { num:3, label:"Contacto"        },
]

export default function Consulta() {
  const [paso, setPaso]   = useState(1)
  const [saliendo, setSaliendo] = useState(false)
  const [form, setForm]   = useState({
    destino:"", zonaBuzios:"", ciudadSalida:"", fechaSalida:"",
    viajerosMayores:"2", viajerosmenores:"0", noches:"7", tipoViaje:"",
    nombre:"", telefono:"", comentario:""
  })
  const [estado, setEstado] = useState("idle") // idle | loading | ok | error

  useEffect(() => {
    document.title = "Consultá tu viaje con Sergio — Low Travel"
    const desc = document.querySelector('meta[name="description"]')
    if (desc) desc.setAttribute("content", "Contanos cómo querés viajar y Sergio te arma una propuesta personalizada. Sin compromiso, respuesta en 24hs.")
    return () => { document.title = "Low Travel — Viajes a Brasil y el Caribe" }
  }, [])

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }))
  const mostrarZona = form.destino.includes("Búzios")

  const irA = (nuevo) => {
    setSaliendo(true)
    setTimeout(() => { setPaso(nuevo); setSaliendo(false) }, 220)
  }

  const validarPaso = () => {
    if (paso === 1) return form.destino && form.ciudadSalida
    if (paso === 2) return form.tipoViaje
    if (paso === 3) return form.nombre && form.telefono
    return false
  }

  const enviar = async () => {
    if (!validarPaso()) { setEstado("error-campos"); return }
    setEstado("loading")
    try {
      const params = new URLSearchParams()
      Object.entries(form).forEach(([k, v]) => params.append(k, v))
      await fetch(APPS_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        body: params
      })
      setEstado("ok")
    } catch {
      setEstado("error")
    }
  }

  if (estado === "ok") return <PantallaExito nombre={form.nombre} />

  return (
    <div className="consulta-page">
      {/* Header mínimo */}
      <header className="consulta-header">
        <Link to="/" className="consulta-header__logo">
          <img src="/LOGO_LT_H.png" alt="Low Travel" height="36" />
        </Link>
        <a
          href="https://wa.me/5491125603574"
          target="_blank" rel="noreferrer"
          className="consulta-header__wa"
        >
          ¿Preferís escribir? → WhatsApp
        </a>
      </header>

      <main className="consulta-main">
        {/* Progress */}
        <div className="consulta-progress">
          {PASOS.map((p, i) => (
            <div key={p.num} className="consulta-progress__item">
              <div className={`consulta-progress__circulo ${paso === p.num ? "activo" : paso > p.num ? "listo" : ""}`}>
                {paso > p.num ? "✓" : p.num}
              </div>
              <span className={`consulta-progress__label ${paso === p.num ? "activo" : ""}`}>{p.label}</span>
              {i < PASOS.length - 1 && <div className={`consulta-progress__linea ${paso > p.num ? "listo" : ""}`} />}
            </div>
          ))}
        </div>

        {/* Contenedor del paso */}
        <div className={`consulta-card ${saliendo ? "saliendo" : "entrando"}`}>

          {/* ── PASO 1 ── */}
          {paso === 1 && (
            <div className="consulta-paso">
              <div className="consulta-paso__header">
                <div className="consulta-paso__num">Paso 1 de 3</div>
                <h1 className="consulta-paso__titulo">¿A dónde querés ir?</h1>
                <p className="consulta-paso__sub">Sergio especializa en Brasil — estos son los destinos con cupos disponibles.</p>
              </div>

              <div className="consulta-campo">
                <label className="consulta-label">Destino *</label>
                <div className="consulta-chips">
                  {DESTINOS.map(d => (
                    <button key={d} type="button"
                      className={`consulta-chip ${form.destino === d ? "activo" : ""}`}
                      aria-label={`Seleccionar destino: ${d}`}
                      onClick={() => set("destino", d)}
                    >{d}</button>
                  ))}
                </div>
              </div>

              {mostrarZona && (
                <div className="consulta-campo">
                  <label className="consulta-label">¿Qué zona de Búzios te interesa?</label>
                  <div className="consulta-chips">
                    {ZONAS_BUZIOS.map(z => (
                      <button key={z} type="button"
                        className={`consulta-chip ${form.zonaBuzios === z ? "activo" : ""}`}
                        onClick={() => set("zonaBuzios", z)}
                      >{z}</button>
                    ))}
                  </div>
                </div>
              )}

              <div className="consulta-fila">
                <div className="consulta-campo">
                  <label className="consulta-label">Ciudad de salida *</label>
                  <div className="consulta-chips">
                    {CIUDADES.map(c => (
                      <button key={c} type="button"
                        className={`consulta-chip ${form.ciudadSalida === c ? "activo" : ""}`}
                        aria-label={`Salir desde ${c}`}
                        onClick={() => set("ciudadSalida", c)}
                      >{c}</button>
                    ))}
                  </div>
                </div>
                <div className="consulta-campo">
                  <label className="consulta-label">¿Cuándo querés viajar?</label>
                  <input className="consulta-input" type="text"
                    placeholder="Ej: Julio 2026"
                    value={form.fechaSalida}
                    onChange={e => set("fechaSalida", e.target.value)}
                  />
                  <span className="consulta-hint">Fecha aproximada o mes está perfecto</span>
                </div>
              </div>
            </div>
          )}

          {/* ── PASO 2 ── */}
          {paso === 2 && (
            <div className="consulta-paso">
              <div className="consulta-paso__header">
                <div className="consulta-paso__num">Paso 2 de 3</div>
                <h1 className="consulta-paso__titulo">¿Cómo viajás?</h1>
                <p className="consulta-paso__sub">Con estos datos Sergio puede armar una propuesta real sin perderse en preguntas.</p>
              </div>

              <div className="consulta-fila">
                <div className="consulta-campo">
                  <label className="consulta-label">Viajeros mayores de 12 años</label>
                  <div className="consulta-chips">
                    {["1","2","3","4","5+"].map(v => (
                      <button key={v} type="button"
                        className={`consulta-chip consulta-chip--num ${form.viajerosMayores === v ? "activo" : ""}`}
                        aria-label={`${v} viajeros mayores`}
                        onClick={() => set("viajerosMayores", v)}
                      >{v}</button>
                    ))}
                  </div>
                </div>
                <div className="consulta-campo">
                  <label className="consulta-label">Menores de 12 años</label>
                  <div className="consulta-chips">
                    {["0","1","2","3+"].map(v => (
                      <button key={v} type="button"
                        className={`consulta-chip consulta-chip--num ${form.viajerosmenores === v ? "activo" : ""}`}
                        aria-label={`${v} menores de 12`}
                        onClick={() => set("viajerosmenores", v)}
                      >{v}</button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="consulta-campo">
                <label className="consulta-label">Cantidad de noches</label>
                <div className="consulta-chips">
                  {["7","8","9","10","Otra"].map(n => (
                    <button key={n} type="button"
                      className={`consulta-chip consulta-chip--num ${form.noches === n ? "activo" : ""}`}
                      aria-label={`${n} noches`}
                      onClick={() => set("noches", n)}
                    >{n}</button>
                  ))}
                </div>
              </div>

              <div className="consulta-campo">
                <label className="consulta-label">Tipo de viaje *</label>
                <p className="consulta-hint" style={{marginBottom:"12px"}}>Esto define el nivel del hospedaje y los servicios incluidos</p>
                <div className="consulta-tipos">
                  {TIPOS_VIAJE.map(t => (
                    <button key={t.val} type="button"
                      className={`consulta-tipo ${form.tipoViaje === t.val ? "activo" : ""}`}
                      aria-label={`Tipo de viaje: ${t.label}`}
                      onClick={() => set("tipoViaje", t.val)}
                    >
                      <span className="consulta-tipo__emoji">{t.emoji}</span>
                      <span className="consulta-tipo__label">{t.label}</span>
                      <span className="consulta-tipo__desc">{t.desc}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ── PASO 3 ── */}
          {paso === 3 && (
            <div className="consulta-paso">
              <div className="consulta-paso__header">
                <div className="consulta-paso__num">Paso 3 de 3</div>
                <h1 className="consulta-paso__titulo">¿Cómo te encontramos?</h1>
                <p className="consulta-paso__sub">Sergio te responde personalmente por WhatsApp con la propuesta.</p>
              </div>

              <div className="consulta-fila">
                <div className="consulta-campo">
                  <label className="consulta-label">Nombre y apellido *</label>
                  <input className="consulta-input" type="text"
                    placeholder="Ej: María González"
                    value={form.nombre}
                    onChange={e => set("nombre", e.target.value)}
                  />
                </div>
                <div className="consulta-campo">
                  <label className="consulta-label">WhatsApp *</label>
                  <input className="consulta-input" type="tel"
                    placeholder="Ej: 1146893113"
                    value={form.telefono}
                    onChange={e => set("telefono", e.target.value)}
                  />
                </div>
              </div>

              <div className="consulta-campo">
                <label className="consulta-label">Comentario o consulta especial</label>
                <textarea className="consulta-textarea" rows={3}
                  placeholder="Algún hotel en mente, actividad especial, necesidad particular..."
                  value={form.comentario}
                  onChange={e => set("comentario", e.target.value)}
                />
              </div>

              {/* Resumen */}
              <div className="consulta-resumen">
                <div className="consulta-resumen__titulo">📋 Tu consulta en resumen</div>
                <div className="consulta-resumen__items">
                  {form.destino     && <span className="consulta-resumen__tag">📍 {form.destino}</span>}
                  {form.ciudadSalida && <span className="consulta-resumen__tag">✈️ Desde {form.ciudadSalida}</span>}
                  {form.fechaSalida  && <span className="consulta-resumen__tag">📅 {form.fechaSalida}</span>}
                  <span className="consulta-resumen__tag">👥 {form.viajerosMayores} viajeros</span>
                  <span className="consulta-resumen__tag">🌙 {form.noches} noches</span>
                  {form.tipoViaje   && <span className="consulta-resumen__tag">
                    {TIPOS_VIAJE.find(t=>t.val===form.tipoViaje)?.emoji} {TIPOS_VIAJE.find(t=>t.val===form.tipoViaje)?.label}
                  </span>}
                </div>
              </div>

              {estado === "error-campos" && (
                <div className="consulta-aviso consulta-aviso--error">
                  ⚠️ Completá nombre y WhatsApp para que Sergio pueda contactarte.
                </div>
              )}
              {estado === "error" && (
                <div className="consulta-aviso consulta-aviso--error">
                  ❌ Error al enviar. Escribile directamente a{" "}
                  <a href="https://wa.me/5491125603574" target="_blank" rel="noreferrer">Sergio por WhatsApp</a>.
                </div>
              )}
            </div>
          )}

          {/* Navegación */}
          <div className="consulta-nav">
            {paso > 1 && (
              <button type="button" className="consulta-nav__back" onClick={() => irA(paso - 1)}>
                ← Volver
              </button>
            )}
            <div style={{ flex: 1 }} />
            {paso < 3 ? (
              <button type="button"
                className={`consulta-nav__next ${!validarPaso() ? "disabled" : ""}`}
                onClick={() => validarPaso() && irA(paso + 1)}
              >
                Continuar →
              </button>
            ) : (
              <button type="button"
                className="consulta-nav__submit"
                onClick={enviar}
                disabled={estado === "loading"}
              >
                {estado === "loading" ? "Enviando..." : "Enviar consulta a Sergio →"}
              </button>
            )}
          </div>

        </div>

        {/* Garantía */}
        <div className="consulta-garantia">
          🔒 Sin compromiso de compra · Sergio responde en menos de 24hs · 100% gratis
        </div>
      </main>
    </div>
  )
}

function PantallaExito({ nombre }) {
  return (
    <div className="consulta-page">
      <header className="consulta-header">
        <Link to="/" className="consulta-header__logo">
          <img src="/LOGO_LT_H.png" alt="Low Travel" height="36" />
        </Link>
      </header>
      <main className="consulta-main consulta-main--exito">
        <div className="consulta-exito">
          <div className="consulta-exito__icono">✅</div>
          <h1 className="consulta-exito__titulo">
            ¡Consulta enviada{nombre ? `, ${nombre.split(" ")[0]}` : ""}!
          </h1>
          <p className="consulta-exito__texto">
            Sergio recibió tu consulta y te va a responder personalmente
            por WhatsApp con opciones y precios a tu medida.
          </p>
          <p className="consulta-exito__tiempo">⏱ Tiempo de respuesta habitual: menos de 24hs hábiles</p>
          <div className="consulta-exito__acciones">
            <a
              href="https://wa.me/5491125603574?text=Hola Sergio! Acabo de completar el formulario de consulta en tu web."
              target="_blank" rel="noreferrer"
              className="consulta-exito__wa"
            >
              También podés escribirle ahora →
            </a>
            <Link to="/propuestas" className="consulta-exito__propuestas">
              Mientras tanto, ver propuestas
            </Link>
          </div>
        </div>
      </main>
    </div>
  )
}
